var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as TabsPrimitives from "@radix-ui/react-tabs";
import React from "react";
import { cx, focusRing } from "../../lib/utils";
const Tabs = (props) => {
    return React.createElement(TabsPrimitives.Root, Object.assign({}, props));
};
Tabs.displayName = "Tabs";
const TabsListVariantContext = React.createContext("line");
const variantStyles = {
    line: cx(
    // base
    "onvo-flex onvo-items-center onvo-justify-start onvo-border-solid onvo-border-b", 
    // border color
    "onvo-border-gray-200 dark:onvo-border-gray-800"),
    solid: cx(
    // base
    "onvo-inline-flex onvo-items-center onvo-justify-center onvo-rounded-md onvo-p-1", 
    // border color
    // "border-gray-200 dark:border-gray-800",
    // background color
    "onvo-bg-gray-100 dark:onvo-bg-gray-800 onvo-background-color"),
};
const TabsList = React.forwardRef((_a, forwardedRef) => {
    var { className, variant = "line", children } = _a, props = __rest(_a, ["className", "variant", "children"]);
    return (React.createElement(TabsPrimitives.List, Object.assign({ ref: forwardedRef, className: cx(variantStyles[variant], className) }, props),
        React.createElement(TabsListVariantContext.Provider, { value: variant }, children)));
});
TabsList.displayName = "TabsList";
function getVariantStyles(tabVariant) {
    switch (tabVariant) {
        case "line":
            return cx(
            // base
            "-onvo-mb-px onvo-items-center onvo-justify-center onvo-whitespace-nowrap onvo-border-solid onvo-border-b-2 onvo-border-transparent onvo-px-3 onvo-pb-3 onvo-text-sm onvo-font-medium onvo-transition-all", 
            // text color
            "onvo-text-gray-500 dark:onvo-text-gray-500", 
            // hover
            "hover:onvo-text-gray-700 hover:dark:onvo-text-gray-400", 
            // border hover
            "hover:onvo-border-gray-300 hover:dark:onvo-border-gray-400", 
            // selected
            "data-[state=active]:onvo-border-gray-900 data-[state=active]:onvo-text-gray-900", "data-[state=active]:dark:onvo-border-gray-50 data-[state=active]:dark:onvo-text-gray-50", 
            // disabled
            "disabled:onvo-pointer-events-none", "disabled:onvo-text-gray-300 disabled:dark:onvo-text-gray-700");
        case "solid":
            return cx(
            // base
            "onvo-inline-flex onvo-items-center onvo-justify-center onvo-whitespace-nowrap onvo-rounded onvo-px-3 onvo-py-1 onvo-transition-all onvo-text-sm onvo-font-medium", 
            // text color
            "onvo-text-gray-500 dark:onvo-text-gray-400", 
            // hover
            "hover:onvo-text-gray-700 hover:dark:onvo-text-gray-200", 
            // selected
            " data-[state=active]:onvo-bg-black/10 data-[state=active]:onvo-text-gray-900 data-[state=active]:onvo-shadow", "data-[state=active]:dark:onvo-bg-white/10 data-[state=active]:dark:onvo-text-gray-50", 
            // disabled
            "disabled:onvo-pointer-events-none disabled:onvo-text-gray-400 disabled:dark:onvo-text-gray-600 disabled:onvo-opacity-50");
    }
}
const TabsTrigger = React.forwardRef((_a, forwardedRef) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const variant = React.useContext(TabsListVariantContext);
    return (React.createElement(TabsPrimitives.Trigger, Object.assign({ ref: forwardedRef, className: cx(getVariantStyles(variant), focusRing, className) }, props), children));
});
TabsTrigger.displayName = "TabsTrigger";
const TabsContent = React.forwardRef((_a, forwardedRef) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(TabsPrimitives.Content, Object.assign({ ref: forwardedRef, className: cx("onvo-outline-none", focusRing, className) }, props)));
});
TabsContent.displayName = "TabsContent";
export { Tabs, TabsContent, TabsList, TabsTrigger };
//# sourceMappingURL=Tabs.js.map